/**
 * KAN-950: tutorial of the current route (null when the page has none).
 * Shared by the floating button and the layout, which reserves room
 * at the bottom of the content for a bottom-right button.
 */
import { useLocation } from 'react-router-dom';
import { findTutorial, type FoundTutorial } from '@/tutorials/registry';

export function useCurrentTutorial(): FoundTutorial | null {
  const { pathname, search } = useLocation();
  // Query picks the tab-specific video (/settings?tab=telegram, /crm?view=board).
  return findTutorial(pathname + search);
}
